// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid2";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import { Divider } from "@mui/material";
import DetailList from "components/DetailList";
import { useEffect, useState } from "react";
import { areAllValuesEmpty } from "components/helper";

const ProductReview = ({ formData }) => {
  const { values } = formData;
  const [productInfoData, setProductInfoData] = useState({});
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (values) {
      const isBreakfast = values?.subTag?.label?.toLowerCase() === "breakfast";

      const data = {
        jobName: values?.productName,
        jobCode: values?.jobCode,
        retailPrice: values?.price,
        netPrice: values?.netPrice,
        currency: values?.price && values?.defaultCurrencyCode,
        tag: values?.tag?.label,
        subTag: values?.subTag?.label,
        email: values?.email,
        phone: values?.phone,
        deliveryMethods: values?.deliveryMethods?.map((method) =>
          method === "noknok"
            ? "External Providers"
            : method.charAt(0).toUpperCase() + method.slice(1)
        ),
        images: values?.images,
        description: values?.description,
        label: values?.label,
        "Tag Id": values?.messageBoxCategoryId,
      };

      if (isBreakfast) {
        data.beverages = values?.beverages;
      }

      setProductInfoData(data);
    }
  }, [values]);

  useEffect(() => {
    setFields([{ id: 0, title: "Job info", data: productInfoData }]);
  }, [productInfoData]);

  return (
    <MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          {fields?.map((field, i) => (
            <Grid
              item
              key={field.id}
              xs={12}
              sx={{
                display: areAllValuesEmpty(field.data) ? "none" : "flex",
                flexDirection: "column",
              }}
            >
              <DetailList data={field.data} title={field?.title} />
              {i + 1 !== fields?.length && (
                <div>
                  <Divider sx={{ height: "1px" }} />
                </div>
              )}{" "}
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </MDBox>
  );
};

// typechecking props for ProductReview
ProductReview.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.func]).isRequired,
  //   editPage: PropTypes.bool,
};

export default ProductReview;
